// External libraries
import styled from '@emotion/styled';

// Internal modules
import {
  DEFAULT_BORDER_COLOR,
  FLAG_SPRITE_POSITION_MAP,
  FLAGS_SPRITE_URL,
  TEXT_COLOR,
} from '@/styles';

const ChangeCountry = styled.button`
  background-clip: content-box;
  background-color: transparent;
  background-image: url(${FLAGS_SPRITE_URL});
  background-position: center
    ${props => FLAG_SPRITE_POSITION_MAP[props.country] + 7}px;
  background-repeat: no-repeat;
  border: 0;
  cursor: pointer;
  height: 30px;
  margin-right: 5px;
  padding: 5px 2px;
  width: 30px;
`;

const CountryLanguageContainer = styled.div`
  align-items: center;
  display: flex;
  height: 18px;
  margin-bottom: 1.6em;
  margin-top: 2em;
`;

const FooterLinks = styled.div`
  align-self: stretch;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: 480px) {
    align-items: center;
    flex-direction: column;
  }
`;

const HorizLine = styled.div`
  border-left: 36px solid ${DEFAULT_BORDER_COLOR};
  border-top: 1px solid ${DEFAULT_BORDER_COLOR};
  box-sizing: content-box;
  height: 0;
  margin-bottom: ${props => (props.hasCancelUrl ? '17px' : '0')};
  width: 100%;
`;

const LinksContainer = styled.div`
  font-size: 11px;
  line-height: 1.64;

  a,
  button {
    color: ${TEXT_COLOR};
    margin: 0 7.5px;
    text-decoration: none;
  }

  @media (max-width: 480px) {
    margin: 0 7.5px 1.2em;
  }
`;

const StyledFooter = styled.footer`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.38;
  margin-bottom: 25px;
  padding-bottom: 18px;
`;

export {
  ChangeCountry,
  CountryLanguageContainer,
  FooterLinks,
  HorizLine,
  LinksContainer,
  StyledFooter,
};
